import { axiosClientMiddleware } from "config/axios/AxiosClient"
import { AxiosResponse, CancelToken } from "axios"
import OMNIX_MODULE from "constants/OMNIX_MODULE"

interface IResponseService<TResult> {
  transactionId?: string
  code: number
  message: TResult
}

export const post_middleware_osrm_search = async (
  entity: string,
  body: any,
  token: string,
  cancelToken?: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const url = `${OMNIX_MODULE.BFF}/${OMNIX_MODULE.OSRM}/search/${entity}`
  const response = await axiosClientMiddleware.post<IResponseService<any>>(url, body, {
    headers: { "Content-Type": "application/json", Authorization: token },
    cancelToken,
  })

  return response
}

export const put_middleware_olm = async (
  path: string,
  body: any,
  token: string,
  cancelToken?: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const url = `${OMNIX_MODULE.BFF}/${OMNIX_MODULE.OLM}/${path}`
  const response = await axiosClientMiddleware.put<IResponseService<any>>(url, body, {
    headers: { "Content-Type": "application/json", Authorization: token },
    cancelToken,
  })

  return response
}